import _isArray from 'lodash/isArray';

import { get, logError } from 'utils';

export default function getRetexesOfOrderService(
  params = {},
  onSuccess = () => {},
  onError = () => {},
  onFinally = () => {}
) {
  return get({ apiKey: 'retexes.getList' }, { params })
    .then(({ data }) => {
      const retexes = _isArray(data) ? data : [];
      onSuccess(retexes);
    })
    .catch(err => {
      logError(err);
      onError(err);
    })
    .finally(onFinally);
}
